import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "row w-full mtop-10 gap-04" }
const _hoisted_4 = { class: "row w-full mtop-10 gap-04" }

import { useI18n } from 'vue-i18n';
import {  CnsDashboard } from '@/apiGenerate/medserver';
import EsDataCard from '@/components/esDataCard.vue';
import { DateFormat } from "@/models/share.model";
import { format } from "date-fns";


export default /*@__PURE__*/_defineComponent({
  __name: 'esCnsDashboard',
  props: {
    groupName: {},
    cnsDashboard: {},
    start: {},
    end: {}
  },
  setup(__props: any) {



const {t} = useI18n();


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('accounting.stats.body.title', {groupName: _ctx.groupName})), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('accounting.stats.body.period', {start: _unref(format)(new Date(_ctx.start), _unref(DateFormat).FRONT_LONG), end: _unref(format)(new Date(_ctx.end), _unref(DateFormat).FRONT_LONG)})), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(EsDataCard, {
        title: _unref(t)('accounting.stats.body.nbMHSent'),
        ref: 'accounting-nbMHSent',
        icon: 'cloud-and-arrow-up_fill',
        folderIcon: 'shareIcons',
        backgroundClass: "bg-blue-04"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _ctx.cnsDashboard.nbMHSent.toString(),
            class: "pleft-30px txt-grey-64"
          }, null, 8, ["txt"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(EsDataCard, {
        title: _unref(t)('accounting.stats.body.nbPidValidated'),
        ref: 'accounting-nbPidValidated',
        icon: 'checkmark-square_fill',
        folderIcon: 'shareIcons',
        backgroundClass: "bg-blue-04"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _ctx.cnsDashboard.nbPidValidated.toString(),
            class: "pleft-30px txt-grey-64"
          }, null, 8, ["txt"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(EsDataCard, {
        title: _unref(t)('accounting.stats.body.nbPidContested'),
        ref: 'accounting-nbPidContested',
        icon: 'xmark-octagon_fill',
        folderIcon: 'shareIcons',
        backgroundClass: "bg-blue-04"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _ctx.cnsDashboard.nbPidContested.toString(),
            class: "pleft-30px txt-grey-64"
          }, null, 8, ["txt"])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}
}

})